// extracted by mini-css-extract-plugin
export default {"name":"Header_name__iBsNn","rightItems":"Header_rightItems__frLjT","header":"Header_header__+q3o8","leftItems":"Header_leftItems__H5rAa","border":"Header_border__RDL4b"};